import React, { useState } from 'react';
import CurrencyConversionPanel from './CurrencyConversionPanel';
import { PaystackStripeBrand } from './PaymentProviderBrand';

export default function PaystackPaymentSection({
  apiBaseUrl,
  idToken,
  orderId,
  amountUsd,
  paystackQuote,
  disabled,
  onError,
}) {
  const [loading, setLoading] = useState(false);
  const [localError, setLocalError] = useState('');

  async function handlePaystack() {
    if (!orderId || !idToken) return;
    setLoading(true);
    setLocalError('');
    try {
      const response = await fetch(`${apiBaseUrl}/api/payments/paystack/initialize`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${idToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          order_id: orderId,
          app_origin: window.location.origin,
        }),
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok) {
        const code = payload.code || '';
        if (code === 'PROVIDER_LOCKED') {
          throw new Error('This checkout was started with PayPal. Refresh the page, then pay with Paystack.');
        }
        throw new Error(payload.error || 'Failed to initialize Paystack payment');
      }
      if (!payload.authorization_url) {
        throw new Error('Paystack redirect URL is unavailable');
      }
      window.location.assign(payload.authorization_url);
    } catch (err) {
      const message = err?.message || 'Paystack checkout failed';
      setLocalError(message);
      if (onError) onError(err instanceof Error ? err : new Error(message));
      setLoading(false);
    }
  }

  return (
    <div className="space-y-4">
      <PaystackStripeBrand size="lg" />

      <p className="text-sm text-slate-600 leading-relaxed">
        Ideal if PayPal is unavailable in your region. Cognidoor plans are priced in{' '}
        <strong className="font-medium text-slate-800">USD</strong>; Paystack charges the{' '}
        <strong className="font-medium text-slate-800">ZAR</strong> equivalent at checkout for
        card and bank payments.
      </p>

      <CurrencyConversionPanel amountUsd={amountUsd} paystackQuote={paystackQuote} />

      {localError ? (
        <div className="text-sm text-red-600" role="alert">
          {localError}
        </div>
      ) : null}

      <div>
        <button
          type="button"
          onClick={handlePaystack}
          disabled={disabled || loading || !orderId}
          className="w-full py-3 rounded-xl font-semibold text-white bg-emerald-600 hover:bg-emerald-700 disabled:opacity-60 disabled:cursor-not-allowed transition-colors text-sm sm:text-base shadow-sm"
        >
          {loading ? 'Redirecting to Paystack…' : 'Pay with Paystack'}
        </button>
        <div className="mt-2 flex justify-center">
          <PaystackStripeBrand size="sm" />
        </div>
      </div>
    </div>
  );
}
